import { useState } from "react";
import DialogFormPanel from "../../../../../../shared/components/panel/DialogFormPanel";
import CreateButtonTrigger from "../../../../../../shared/components/button/CreateButtonTrigger";
import AddCCSectionPermissionForm from "./AddCCSectionPermissionForm";

const AddCCSectionPermissionDialog = ({ onSubmitHandler, sections }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title="Añadir sección"
      description="Añadir una nueva sección a los permisos del Control Centre"
      content={
        <AddCCSectionPermissionForm
          onSubmitHandler={onSubmit}
          sections={sections}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default AddCCSectionPermissionDialog;
